module.exports = __webpack_public_path__ + "img/brooksbg.705348cf.jpg";